import React, { useEffect, useState } from 'react';
import { Alert, Button, Card, Spinner, Tab } from 'react-bootstrap';
import { useParams } from 'react-router-dom';

import Tabs from '../../../app/components/Tabs';
import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { useNavigation } from '../../../common/navigation';
import {
  GetExamDto,
  GetIndicatorTestRecalculatedDto,
} from '../../../common/spdCore/autogenerated/spdApiClient';
import { IndicatorTestsInExam } from '../../components/IndicatorTestInExam/IndicatorTestInExam';

type ParamTypes = {
  id: string;
};

export const IndicatorTestsInExamView: React.FC = () => {
  const spd = useSpdCore();
  const nav = useNavigation();
  const [indicatorTest, setIndicatorTest] = useState<
    GetIndicatorTestRecalculatedDto[]
  >([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [exam, setExam] = useState<GetExamDto | null | undefined>();

  const { id } = useParams<ParamTypes>() as { id: string };

  useEffect(() => {
    setLoading(true);
    let mounted = true;
    spd.examTests
      .get(id)
      .then(examT => {
        if (mounted) {
          setExam(examT?.exam);
          spd.indicatorTests
            .getByExamTest(examT.id)
            .then(res => {
              if (mounted) {
                setIndicatorTest(res);
                setLoading(false);
              }
            })
            .catch(error => {
              setLoading(false);
              console.log(`Wystąpił problem z odświeżeniem strony. ${error}`);
            });
        }
      })
      .catch(error => {
        setLoading(false);
        console.log(`Wystąpił problem z odświeżeniem strony. ${error}`);
      });

    return () => {
      mounted = false;
    };
  }, [id, spd.indicatorTests, spd.examTests]);

  return (
    <Card>
      <Tabs defaultActiveKey="indicators" id="examTests" className="mb-3">
        <Tab
          eventKey="indicators"
          title={`Wskaźniki: Badanie ${exam?.number || ''}, ${
            exam?.examined?.firstname || ''
          } ${exam?.examined?.surname || ''} - ${
            indicatorTest?.[0]?.test?.name || ''
          }`}
          className="m-3"
        >
          {loading && (
            <Alert variant="info">
              <Spinner size="sm" className="mx-2" />
              Trwa generowanie wskaźników. Proszę czekać...
            </Alert>
          )}
          <IndicatorTestsInExam data={indicatorTest} />
          {exam?.id && (
            <Button
              variant="outline-secondary"
              className="ms-1"
              onClick={() => void nav.examTests(exam?.id)}
            >
              Testy badania
            </Button>
          )}
          {exam?.id && (
            <Button
              variant="outline-secondary"
              className="ms-1"
              onClick={() => void nav.results(id)}
            >
              Wyniki badania
            </Button>
          )}
        </Tab>
      </Tabs>
    </Card>
  );
};
